import { IAutoMapper } from "../../../../../core/automapper/interfaces";

export const mapDataAllocation = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "DataAllocation")
    .forMember("metric", o => o.metric)
    .forMember("compliant", o => o.compliant)
    .forMember("partialCompliant", o => o.partialCompliant)
    .forMember("nonCompliant", o => o.nonCompliant)
    .forMember("exclusion", o => o.exclusion);
};

export type DataAllocationValue = number | string | null;

export const DATA_ALLOCATION_METRICS = [
  "Total intake to date",
  "Selected for overread",
  "Measure Contribution",
  "Random Fill Contribution",
  "Total Chases Routed",
  "Cap Status",
];

export class DataAllocation {
  metric: string;
  compliant: DataAllocationValue;
  partialCompliant: DataAllocationValue;
  nonCompliant: DataAllocationValue;
  exclusion: DataAllocationValue;

  constructor(options: Partial<DataAllocation> = {}) {
    this.metric = options.metric ?? "";
    this.compliant = options.compliant ?? null;
    this.partialCompliant = options.partialCompliant ?? null;
    this.nonCompliant = options.nonCompliant ?? null;
    this.exclusion = options.exclusion ?? null;
  }
}
